"use strict"

import React, { useEffect, useState } from "react"
import { isNumber } from "../../../utils"
import { isLTPM } from "../../../../components/shared_components_registration"

const registration = {
  y_axis_label: (intl) => (isLTPM ? intl.formatMessage({ id: "graphing.y.axis" }) : "Y-Axis"),
  x_axis_label: (intl) => (isLTPM ? intl.formatMessage({ id: "graphing.x.axis" }) : "X-Axis"),
  min_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.min" }) : "Min"),
  max_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.max" }) : "Max"),
}

export default function YAxesRangeInputs({
  intl,
  disabled,
  axis,
  axis_number,
  zoomRanges,
  graphKey,
  plotConfigUpdater,
  graphIndex,
}) {
  let zoomDomain, domainName
  if (axis + axis_number === "Y1") {
    zoomDomain = zoomRanges.y
    domainName = "axis1domain"
  } else if (axis + axis_number === "Y2") {
    zoomDomain = zoomRanges.y2
    domainName = "axis2domain"
  } else {
    zoomDomain = zoomRanges.x
    domainName = "xaxisdomain"
  }

  let domain = graphKey[domainName] || []
  const hasDomainRange = domain.length === 2
  const [min, setMin] = useState(hasDomainRange && isNumber(domain[0]) ? domain[0] : "")
  const [max, setMax] = useState(hasDomainRange && isNumber(domain[1]) ? domain[1] : "")

  useEffect(() => {
    const domain = graphKey[domainName] || []
    const hasDomainRange = domain.length === 2
    const min_value = hasDomainRange && isNumber(domain[0]) ? domain[0] : ""
    const max_value = hasDomainRange && isNumber(domain[1]) ? domain[1] : ""
    setMin(min_value)
    setMax(max_value)
  }, [graphKey.axis1domain, graphKey.axis2domain, graphKey.xaxisdomain])

  const updateAxisDomain = (ev, position) => {
    ev.preventDefault()

    const graph = Object.assign({}, graphKey)
    const value = isNumber(parseFloat(ev.target.value)) ? parseFloat(ev.target.value) : ev.target.value
    position === "min" ? setMin(value) : setMax(value)

    if (hasDomainRange) {
      position === "min" ? (domain[0] = value) : (domain[1] = value)
    } else {
      position === "min" ? (domain = [value, null]) : (domain = [null, value])
    }

    if (domain.every((x) => x === "" || !isNumber(x))) {
      delete graph[domainName]
    } else {
      graph[domainName] = domain
    }

    plotConfigUpdater(graph, graphIndex)
  }

  return (
    <div className={"row"}>
      <div className={"col-4"} style={{ marginBottom: "10px" }}>
        <label>
          {axis === "Y" ? (
            <span>{`${registration.y_axis_label(intl)} ${axis_number}`}</span>
          ) : (
            <span>{`${registration.x_axis_label(intl)} ${axis_number}`}</span>
          )}
        </label>
      </div>
      <div className={"col-8"} style={{ marginBottom: "10px" }}>
        <div className={"row"} style={{ marginBottom: "2px" }}>
          <div className={"col-4"}>
            <label>{registration.min_label(intl)}:</label>
          </div>
          <div className={"col-8"}>
            <input
              type="number"
              step={"0.1"}
              style={{ width: "100%" }}
              disabled={disabled || zoomDomain}
              value={hasDomainRange && isNumber(domain[0]) ? domain[0] : min}
              onChange={(ev) => updateAxisDomain(ev, "min")}
            />
          </div>
        </div>
        <div className={"row"}>
          <div className={"col-4"}>
            <label style={{ marginRight: "5px" }}>{registration.max_label(intl)}:</label>
          </div>
          <div className={"col-8"}>
            <input
              type="number"
              step={"0.1"}
              style={{ width: "100%" }}
              disabled={disabled || zoomDomain}
              value={hasDomainRange && isNumber(domain[1]) ? domain[1] : max}
              onChange={(ev) => updateAxisDomain(ev, "max")}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
